define([
    "dojo/_base/declare",
    "csi/heading/Ref"
], function(declare,Ref) {

    return declare(Ref, {
        _getReferencedNode: function(/*Context*/ctx, /*Heading*/h) {
            // summary: return selected ProductSalesRegionSpec.  activeProductSalesRegion is probably not in the cache since comes from SR
            var productSalesRegion = ctx.cache.getNode(ctx.view.activeProductSalesRegion, true);

            if (productSalesRegion)
                return ctx.cache.getNode(productSalesRegion.ProductSalesRegionSpec, true);

            return null;
        },

        getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
            // summary: disable filtering
            return null;
        }

    });
});